<template lang="pug">
div
  b-tooltip(target="notifications", title="Notifications", triggers="hover")
  b-nav-item-dropdown.notif-item
    template(slot='button-content')
      img#notifications(src='../../assets/nav/bell.svg')
      .badge.d-flex.align-items-center.justify-content-center(v-if='notifications.length > 0')
        span {{ notifications.length }}
    b-dropdown-item.notif.empty(v-if='notifications.length === 0')
      .empty-wrap
        img(src='../../assets/metamask/hiding-sprite.svg')
        div Nothing here, yet.
    b-dropdown-item.notif(
      v-for='notification in notifications',
      :key='notification.id',
      @click='viewNotification(notification)')
      | {{ notification.title }}
</template>

<style>
  .notif-item .dropdown-toggle::after {
    border: none !important;
  }

  .notif-item .dropdown-menu {
    margin-left: -4rem;
  }
</style>

<style lang="scss" scoped>
  .badge {
    background: #e14455;
    color: #fff;
    width: 20px;
    height: 20px;
    font-size: 10px;
    text-align: center;
    border-radius: 50%;
    position: absolute;
    top: 15px;
    right: 3px;
  }

  .notif {
    text-transform: none;
    font-size: 12px;
  }

  .notif:hover, .notif:focus {
    border: none;
    outline: none;
  }

  .notif.empty {
    cursor: default;
    background: #fff;
  }

  .empty-wrap {
    img {
      margin: 0 auto;
      display: block;
      margin-bottom: .5rem;
    }
  }
</style>

<script>
import moment from 'moment';

import { bossById } from '../../lib/boss';

export default {
  methods: {
    viewNotification(notification) {
      if (notification.type === 'event') {
        this.$root.$emit('show-event-detail', notification.id);
      } else {
        this.$root.$emit('show-sprite-detail', { sprite: notification.sprite });
      }
    },
  },
  computed: {
    viewedActivityDates() {
      return this.$store.state.viewedActivityDates;
    },
    completedEvents() {
      return this.$store.state.events.filter(event => (event.completed || event.eventOptions.status === 'defeat'));
    },
    userSprites() {
      return this.$store.state.usersMonsters;
    },
    notifications() {
      const completedNotifs = [];

      const eventNotifs = this.completedEvents.map((event) => {
        if (this.viewedActivityDates[event._id]) {
          const defeated = event.eventOptions.status === 'defeat';

          const copletedMessage = `You completed an event against ${bossById[event.eventOptions.boss]}`;
          const defeatMessage = `You were defeated by ${bossById[event.eventOptions.boss]}`;

          return {
            id: event._id,
            title: defeated ? defeatMessage : copletedMessage,
            type: 'event',
          };
        }
      });

      const spriteNotifs = this.userSprites.map((sprite) => {
        if (!sprite.recentActivity) return;
        const lastViewedDate = this.viewedActivityDates[sprite._id];

        const unseenActivity = sprite.recentActivity.filter((act) => {
          return lastViewedDate ? moment(lastViewedDate).isBefore(act.createdAt) : true;
        });

        const hasLevel = unseenActivity.find((activity) => {
          return activity.reason.indexOf('level') !== -1;
        });

        if (!hasLevel) return;

        return {
          id: sprite._id,
          title: `${sprite.name} has leveled up!`,
          type: 'sprite',
          sprite,
        };
      })

      const eventNotifsClean = eventNotifs.filter(event => Boolean(event));
      const spriteNotifsClean = spriteNotifs.filter(event => Boolean(event));

      return completedNotifs.concat(eventNotifsClean).concat(spriteNotifsClean);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/nav/Notifications.vue